/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsnav_Systemgroup2Inputs */

const zh_settingsnav_systemgroup2 = /** @type {(inputs: Settingsnav_Systemgroup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统`)
};

const en_settingsnav_systemgroup2 = /** @type {(inputs: Settingsnav_Systemgroup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

const es_settingsnav_systemgroup2 = /** @type {(inputs: Settingsnav_Systemgroup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema`)
};

/**
* | output |
* | --- |
* | "System" |
*
* @param {Settingsnav_Systemgroup2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const settingsnav_systemgroup2 = /** @type {((inputs?: Settingsnav_Systemgroup2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsnav_Systemgroup2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_settingsnav_systemgroup2(inputs)
	if (locale === "en") return en_settingsnav_systemgroup2(inputs)
	return es_settingsnav_systemgroup2(inputs)
});
export { settingsnav_systemgroup2 as "settingsNav_systemGroup" }